// bdeConfig.ts

export const weekLabels = ["Week 1", "Week 2", "Week 3", "Week 4"];

export const performanceData = [
  { week: "Week 1", leads: 5, deals: 8, accounts: 4, contacts: 10 },
  { week: "Week 2", leads: 6, deals: 9, accounts: 2, contacts: 13 },
  { week: "Week 3", leads: 8, deals: 4, accounts: 7, contacts: 10 },
  { week: "Week 4", leads: 4, deals: 11, accounts: 8, contacts: 9 },
];

export const chartSeries = [
  { key: "leads", label: "Leads", color: "#22c55e" },     // green
  { key: "deals", label: "Deals", color: "#f97316" },     // orange
  { key: "accounts", label: "Accounts", color: "#3b82f6" }, // blue
  { key: "contacts", label: "Contacts", color: "#06b6d4" }, // cyan
];
